"use client";

import { GridBorderedSection, GridDivider } from "@/components/homepage/GridLayout";
import { HomepageFooter } from "@/components/homepage/HomepageFooter";
import { PageLayout } from "@/components/ui/page-layout";
import { useIsAuthenticated } from "@/hooks/useIsAuthenticated";
import type { ReactNode } from "react";

export function X402SectionPageShell({ hero, grid }: { hero: ReactNode; grid: ReactNode }) {
  const isAuthenticated = useIsAuthenticated();

  if (isAuthenticated) {
    return (
      <PageLayout>
        <div className="flex flex-col gap-8">
          {hero}
          {grid}
        </div>
      </PageLayout>
    );
  }

  return (
    <div className="bg-ds-surface-primary relative min-h-screen">
      <div className="relative z-[2] px-4 2xl:px-0">
        <GridBorderedSection className="h-[72px]" />
        <GridDivider variant={2} />
        <GridBorderedSection>
          <div className="mx-auto w-full max-w-[1440px] px-2 py-8 sm:px-6 md:px-[41px]">{hero}</div>
        </GridBorderedSection>
        <GridDivider variant={2} />
        <GridBorderedSection>
          <div className="relative z-[2] mx-auto w-full max-w-[1440px] pb-16 pt-8 sm:px-6 md:px-[41px]">{grid}</div>
        </GridBorderedSection>
        <GridDivider variant={2} />
      </div>

      <HomepageFooter />
    </div>
  );
}
